import React, { Fragment, useContext } from 'react';
import { v4 as uuid } from 'uuid';
import { UPLOAD_STATUS } from '../../shared/utils/constants';
import UploadItem from './components/UploadItem';
import SmartContext from '../App/context/SmartContext';

const UploadCentral = () => {
  const context = useContext(SmartContext);
  const {
    filesToUpload,
    currentTusUpload,
    updateFileToPauseUploadStatus,
    updateFileToUploadingUploadStatus,
  } = context;

  const setPauseOrPlayUpload = async (fileToControl) => {
    const { status } = fileToControl;
    const terminateUpload = false;
    try {
      if (status === UPLOAD_STATUS.PAUSE) {
        currentTusUpload.start();
        updateFileToUploadingUploadStatus(fileToControl);
      } else {
        currentTusUpload.abort(terminateUpload);
        updateFileToPauseUploadStatus(fileToControl);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Fragment>
      {filesToUpload.map((item) => (
        <UploadItem
          key={uuid()}
          fileName={item.content.name || 'SmartVideo'}
          ownerName="Comunicado"
          status={item.status}
          onClickButtonControlUpload={() => setPauseOrPlayUpload(item)}
          preview={item.content.preview}
        />
      ))}
    </Fragment>
  );
};

export default UploadCentral;
